'use client';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import './subComponent/Icons_Section.css';
export default function Icons_Section({ activeStep = 0 }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(768)); // md = 900px
  // Desktop + Tablet scroll animations
  useEffect(() => {
    if (isMobile) return;
    const icons = [
      { selector: '.icon-reveal1', trigger: 366 },
      { selector: '.icon-reveal4', trigger: 366 },
      { selector: '.icon-reveal2', trigger: 514 },
      { selector: '.icon-reveal5', trigger: 514 },
      { selector: '.icon-reveal3', trigger: 600 },
      { selector: '.icon-reveal6', trigger: 600 },
    ];
    const disappearTrigger = 950;
    const moveLeftEnterTrigger = disappearTrigger;
    const moveLeftExitTrigger = disappearTrigger;
    const timeouts = new Set();
    let isCenterMovedLeft = false;
    const handleScroll = () => {
      const scrollY =
        window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
      icons.forEach(({ selector, trigger }) => {
        const elements = document.querySelectorAll(selector);
        elements.forEach((el, i) => {
          const shouldShow = scrollY >= trigger && scrollY < disappearTrigger;
          const shouldHide = scrollY >= disappearTrigger;

          if (shouldShow) {
            if (!el.classList.contains('show') && el.dataset.revealPending !== '1') {
              el.dataset.revealPending = '1';
              const t = setTimeout(() => {
                el.classList.add('show');
                el.classList.remove('hide');
                delete el.dataset.revealPending;
                timeouts.delete(t);
              }, i * 200);
              timeouts.add(t);
            }
            el.classList.remove('hide');
          } else if (shouldHide) {
            delete el.dataset.revealPending;
            el.classList.add('hide');
            el.classList.remove('show');
          } else {
            delete el.dataset.revealPending;
            el.classList.remove('show');
            el.classList.remove('hide');
          }
        });
      });
      const mobileImage = document.querySelector('.mobile-image');
      const contentSection = document.querySelector('.content-section');
      if (mobileImage && contentSection) {
        if (!isCenterMovedLeft && scrollY >= moveLeftEnterTrigger) {
          isCenterMovedLeft = true;
        } else if (isCenterMovedLeft && scrollY <= moveLeftExitTrigger) {
          isCenterMovedLeft = false;
        }

        if (isCenterMovedLeft) {
          mobileImage.classList.add('move-left');
          contentSection.classList.add('show-content');
        } else {
          mobileImage.classList.remove('move-left');
          contentSection.classList.remove('show-content');
        }
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => {
      window.removeEventListener('scroll', handleScroll);
      timeouts.forEach((t) => clearTimeout(t));
      timeouts.clear();
    };
  }, [isMobile]);
  // Optional: when switching to mobile, clean desktop classes so nothing gets stuck
  useEffect(() => {
    if (!isMobile) return;
    const desktopEls = document.querySelectorAll(
      '.icon-reveal1,.icon-reveal2,.icon-reveal3,.icon-reveal4,.icon-reveal5,.icon-reveal6,.mobile-image,.content-section'
    );
    desktopEls.forEach((el) => {
      el.classList.remove('show', 'hide', 'move-left', 'show-content');
    });
  }, [isMobile]);
  // MOBILE animations — runs ONLY on mobile
  useEffect(() => {
    if (!isMobile) return;
    const contentSection = document.querySelector('.content-mobile');
    if (!(contentSection instanceof HTMLElement)) return;
    if (activeStep === 3) contentSection.classList.add('show');
    else contentSection.classList.remove('show');
  }, [isMobile, activeStep]);
  const getImgSize = () => {
    switch (activeStep) {
      case 1:
        return { width: '90vw', height: '50vh' };
      case 2:
        return { width: '90vw', height: '90vh' };
      case 3:
        return { width: '90vw', height: '50vh' };
      case 4:
        return { width: '90vw', height: '90vh' };
      default:
        return { width: '90vw', height: '90vh' };
    }
  };
  // LEFT SIDE (desktop)
  const leftSide = (
    <Box
      sx={{
        position: 'absolute',
        left: '20%',
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        flexDirection: 'column',
        gap: '40px',
      }}
    >
      <Box className="icon-reveal1 icon-reveal icon-left" sx={{ opacity: 0 }}>
        <Box component="img" src="/Favorite_fill.svg" sx={{ width: 56, height: 56 }} />
        <Typography
          sx={{ fontSize: '32px', color: 'white', fontFamily: 'Rammetto One', fontWeight: 800 }}
        >
          LIKE
        </Typography>
      </Box>
      <Box className="icon-reveal2 icon-reveal icon-left" sx={{ opacity: 0 }}>
        <Box component="img" src="/Chat_alt_2_fill.svg" sx={{ width: 56, height: 56 }} />
        <Typography
          sx={{ fontSize: '32px', color: 'white', fontFamily: 'Rammetto One', fontWeight: 800 }}
        >
          COMMENT
        </Typography>
      </Box>
      <Box className="icon-reveal3 icon-reveal icon-left" sx={{ opacity: 0 }}>
        <Box component="img" src="/Share.svg" sx={{ width: 56, height: 56 }} />
        <Typography
          sx={{ fontSize: '32px', color: 'white', fontFamily: 'Rammetto One', fontWeight: 800 }}
        >
          SHARE
        </Typography>
      </Box>
    </Box>
  );
  // RIGHT SIDE (desktop)
  const rightSide = (
    <Box
      sx={{
        position: 'absolute',
        right: '15%',
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        flexDirection: 'column',
        gap: '40px',
      }}
    >
      <Box className="icon-reveal4 icon-reveal icon-right" sx={{ opacity: 0 }}>
        <Box component="img" src="/save.svg" sx={{ width: 56, height: 56 }} />
        <Typography
          sx={{ fontSize: '32px', color: 'white', fontFamily: 'Rammetto One', fontWeight: 800 }}
        >
          FAVOURITE
        </Typography>
      </Box>
      <Box className="icon-reveal5 icon-reveal icon-right" sx={{ opacity: 0 }}>
        <Box component="img" src="/download.svg" sx={{ width: 56, height: 56 }} />
        <Typography
          sx={{ fontSize: '32px', color: 'white', fontFamily: 'Rammetto One', fontWeight: 800 }}
        >
          DOWNLOAD
        </Typography>
      </Box>
      <Box className="icon-reveal6 icon-reveal icon-right" sx={{ opacity: 0 }}>
        <Box component="img" src="/wish.svg" sx={{ width: 56, height: 56 }} />
        <Typography
          sx={{ fontSize: '32px', color: 'white', fontFamily: 'Rammetto One', fontWeight: 800 }}
        >
          WISHLIST
        </Typography>
      </Box>
    </Box>
  );
  // CENTER (desktop)
  const center = (
    <Box
      className="mobile-image"
      sx={{
        position: 'absolute',
        left: { md: '66%', lg: '64%', xl: '60%' },
        marginRight: '256px',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '32px',
        transition: 'transform 0.5s ease-out',
        willChange: 'transform',
        backfaceVisibility: 'hidden',
        WebkitBackfaceVisibility: 'hidden',
        zIndex: 50,
      }}
    >
      <Box component="img" src="/mobile.png" sx={{ width: 240 }} />
      <Box
        className="content-section"
        sx={{
          opacity: 0,
          transform: 'translateX(-10px)',
          transition: 'transform 0.5s ease, opacity 0.5s ease',
          willChange: 'transform, opacity',
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '32px', sm: '40px', md: '48px' },
            fontWeight: 800,
            lineHeight: '1.25',
            color: 'white',
            fontFamily: 'Rammetto One',
            textTransform: 'uppercase',
            textAlign: 'left',
          }}
        >
          Sponsored Tag
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: '14px', sm: '16px', md: '18px' },
            color: 'rgb(209 213 219)',
            mt: 2,
            letterSpacing: '0.025em',
            fontFamily: 'Poppins, sans-serif',
            textTransform: 'uppercase',
            textAlign: 'left',
          }}
        >
          BingePlay highlights selected gamics with a Sponsored tag to give them premium visibility
          across the platform. Sponsored gamics appear in high-traffic placements to drive more
          plays, higher engagement, and more installs.
        </Typography>
      </Box>
    </Box>
  );
  const DesktopLayout = (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        height: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {leftSide}
      {center}
      {rightSide}
    </Box>
  );
  const MobileLayout = (
    <Box sx={{ position: 'relative', height: '100vh' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Box
          component="img"
          src="/mobile.png"
          sx={{
            mx: 'auto',
            transition: 'all 1s',
            mt: 2,
            ...getImgSize(),
            objectFit: 'contain',
          }}
        />
        <Box
          sx={{
            display: 'flex',
            overflow: 'hidden',
            minWidth: '100vw',
            justifyContent: 'center',
            mt: 4,
          }}
        >
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: 2,
            }}
          >
            {/* Left column */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                transform: activeStep === 1 ? 'translateX(0)' : 'translateX(-96px)',
                opacity: activeStep === 1 ? 1 : 0,
                transition: 'all 1s',
              }}
            >
              <Box
                sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}
              >
                <Box component="img" src="/Favorite_fill.svg" sx={{ width: 32, height: 32 }} />
                <Typography sx={{ fontSize: '17px', color: 'white', fontFamily: 'Rammetto One' }}>
                  LIKE
                </Typography>
              </Box>
              <Box
                sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}
              >
                <Box component="img" src="/Chat_alt_2_fill.svg" sx={{ width: 32, height: 32 }} />
                <Typography sx={{ fontSize: '17px', color: 'white', fontFamily: 'Rammetto One' }}>
                  COMMENT
                </Typography>
              </Box>
              <Box
                sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}
              >
                <Box component="img" src="/Share.svg" sx={{ width: 32, height: 32 }} />
                <Typography sx={{ fontSize: '17px', color: 'white', fontFamily: 'Rammetto One' }}>
                  SHARE
                </Typography>
              </Box>
            </Box>
            {/* Right column */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                transform: activeStep === 1 ? 'translateX(0)' : 'translateX(96px)',
                opacity: activeStep === 1 ? 1 : 0,
                transition: 'all 1s',
              }}
            >
              <Box
                sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}
              >
                <Box component="img" src="/save.svg" sx={{ width: 32, height: 32 }} />
                <Typography sx={{ fontSize: '18px', color: 'white', fontFamily: 'Rammetto One' }}>
                  FAVOURITE
                </Typography>
              </Box>
              <Box
                sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}
              >
                <Box component="img" src="/download.svg" sx={{ width: 32, height: 32 }} />
                <Typography sx={{ fontSize: '18px', color: 'white', fontFamily: 'Rammetto One' }}>
                  DOWNLOAD
                </Typography>
              </Box>
              <Box
                sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}
              >
                <Box component="img" src="/wish.svg" sx={{ width: 32, height: 32 }} />
                <Typography sx={{ fontSize: '17px', color: 'white', fontFamily: 'Rammetto One' }}>
                  WISHLIST
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          className="content-mobile"
          sx={{
            mt: '-240px !important',
            maxWidth: '82%',
            textAlign: 'center',
            textTransform: 'uppercase',
          }}
        >
          <Typography
            sx={{
              fontSize: '32px',
              color: 'white',
              fontFamily: 'Rammetto One',
              fontWeight: 800,
              lineHeight: '38px',
            }}
          >
            Sponsored Tag
          </Typography>

          <Typography
            sx={{
              fontSize: '18px',
              color: 'rgb(209 213 219)',
              mt: 1.5,
              fontFamily: 'Poppins, sans-serif',
            }}
          >
            BingePlay highlights selected gamics with a Sponsored tag to give them premium
            visibility across the platform. Sponsored gamics appear in high-traffic placements to
            drive more plays, higher engagement, and more installs.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
  return <Box component="section">{isMobile ? MobileLayout : DesktopLayout}</Box>;
}
Icons_Section.propTypes = {
  activeStep: PropTypes.number,
};
